var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { isNullOrUndefined } from '../../utils/functions';
var DatePickerComponent = /** @class */ (function (_super) {
    __extends(DatePickerComponent, _super);
    function DatePickerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DatePickerComponent.prototype, "placeholder", {
        get: function () {
            return this.showPlaceholder ? this.format : '';
        },
        enumerable: true,
        configurable: true
    });
    DatePickerComponent.prototype.mounted = function () {
        this._datePickerElement = $('.datepicker', this.$el);
        this._datePickerInputElement = $('input', this._datePickerElement);
        var vm = this;
        //Initialize DatePicker
        this._datePickerElement
            .datepicker({
            format: vm.format,
            autoclose: true
        });
        if (!isNullOrUndefined(this.value)) {
            //For some reason the DatePicker library defaults to today if value is not set explicitly
            if (typeof this.value === "string") {
                this._datePickerElement
                    .datepicker('update', new Date(this.value));
            }
            else {
                //Set this initial value
                this._datePickerElement
                    .datepicker('update', this.value);
            }
        }
        ;
        //Listen for changes in selected value and propagate new value to Vue
        this._datePickerElement
            .on('changeDate', function (e) {
            var dayOfMonth = e.date.getDate();
            var month = e.date.getMonth();
            var year = e.date.getFullYear();
            var date = new Date().getTimezoneOffset() <= 0
                // Positive time zone, so for example Brussels
                ? new Date(Date.UTC(year, month, dayOfMonth))
                // Negative time zone, so for example San Fransisco
                : new Date(year, month, dayOfMonth);
            vm.$emit('input', date);
        });
        //Listen for manual changes in the input element
        this._datePickerInputElement.on('blur', function () {
            var value = $(this).val();
            if (!value || value.trim().length === 0) {
                vm.$emit('input', null);
                return;
            }
            var date = vm._datePickerElement.datepicker('getDate');
            var dayOfMonth = date.getDate();
            var month = date.getMonth();
            var year = date.getFullYear();
            var newDate = new Date().getTimezoneOffset() <= 0
                // Positive time zone, so for example Brussels
                ? new Date(Date.UTC(year, month, dayOfMonth))
                // Negative time zone, so for example San Fransisco
                : new Date(year, month, dayOfMonth);
            // Every click on next/previous month/year/decade triggers this event, this if prevents submitting the new date every time
            if (!vm.areDatesEqual(newDate, vm.value)) {
                vm.$emit('input', newDate);
            }
        });
    };
    DatePickerComponent.prototype.areDatesEqual = function (newDate, oldDate) {
        return this.getDateTyped(newDate).toLocaleDateString() === this.getDateTyped(oldDate).toLocaleDateString();
    };
    DatePickerComponent.prototype.getDateTyped = function (value) {
        if (typeof value === "string") {
            return new Date(value);
        }
        return value;
    };
    DatePickerComponent.prototype.onValueChanged = function (value) {
        if (typeof value === "string") {
            value = new Date(value);
        }
        this._datePickerElement
            //Set the new value
            .datepicker('update', value);
    };
    DatePickerComponent.prototype.beforeDestroy = function () {
        this._datePickerInputElement
            //Remove any event handler
            .off();
        this._datePickerElement
            //Remove any event handler
            .off()
            //Destroy DatePicker
            .datepicker('destroy');
    };
    var _a, _b;
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
    ], DatePickerComponent.prototype, "value", void 0);
    __decorate([
        Prop({ default: 'dd/mm/yyyy' }),
        __metadata("design:type", String)
    ], DatePickerComponent.prototype, "format", void 0);
    __decorate([
        Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], DatePickerComponent.prototype, "showPlaceholder", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], DatePickerComponent.prototype, "disabled", void 0);
    __decorate([
        Watch('value'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], DatePickerComponent.prototype, "onValueChanged", null);
    DatePickerComponent = __decorate([
        Component({
            name: 'DatePicker'
        })
    ], DatePickerComponent);
    return DatePickerComponent;
}(Vue));
export default DatePickerComponent;
